module.exports = __webpack_public_path__ + "img/online6.98378ded.jpg";